import type { AdButlerApiResponse } from '../types';

const reportEligibility = (data: AdButlerApiResponse): void => {
  const eligibleUrl = data.placements.placement_1.eligible_url;

  if (!eligibleUrl) {
    return;
  }

  if (eligibleUrl) {
    fetch(eligibleUrl);
  }
};

export default reportEligibility;
